module.exports = __webpack_public_path__ + "static/media/Responsibility Bias - miguel-bruna-TzVN0xQhWaQ-unsplash.e7b12ba6.jpg";